<h2 mat-dialog-title>{{ title | translate }} - <span style="color: red">{{ languageSuffix | translate }}</span></h2>

<form [formGroup]="form">
   <mat-dialog-content style="display: flex; flex-direction: column; gap: 16px; min-width: 320px">
      <mat-form-field appearance="fill">
         <mat-label>{{ this.language === 'EN' ? 'Comment' : 'Megjegyzés' }}</mat-label>
         <textarea matInput formControlName="comment" rows="4"></textarea>
         <mat-hint>{{ 'Optional' | translate }}</mat-hint>
      </mat-form-field>
   </mat-dialog-content>

   <mat-dialog-actions align="end">
      <button type="button" mat-button mat-dialog-close>
         {{ 'Cancel' | translate }}
      </button>
      <button
         type="button"
         mat-flat-button
         color="primary"
         [disabled]="form.invalid"
         (click)="onSubmit()"
      >
         {{ 'Send' | translate }}
      </button>
   </mat-dialog-actions>
</form>
